import apiClient from "../apiClient";
import { NOTIFICATION_ENDPOINTS } from "../endpoints/notifications";
import { getGuestId, getUserId } from "@/utils/session";
import {
  getNotificationCountryOrigin,
  normalizeNotificationsResponse,
} from "@/utils/notificationHelpers";
import {
  buildNotificationClickTrackingPayload,
  buildUserTrackingPayload,
} from "@/utils/userTracking";

export async function saveFirebaseToken(payload) {
  const response = await apiClient.post(
    NOTIFICATION_ENDPOINTS.saveFirebaseToken,
    payload
  );
  return response.data;
}

export async function getRecentNotifications({
  page = 0,
  pageSize = 10,
  status = 0,
  hours = 0,
} = {}) {
  const response = await apiClient.post(
    NOTIFICATION_ENDPOINTS.getRecentNotifications,
    {
      deviceId: getGuestId(),
      userId: Number(getUserId()) || 0,
      countryOrigin: getNotificationCountryOrigin(),
      page,
      pageSize,
      status,
      hours
    }
  );

  return normalizeNotificationsResponse(response.data);
}

export async function postUserTracking(payload) {
  const response = await apiClient.post(
    NOTIFICATION_ENDPOINTS.userTracking,
    payload
  );
  return response.data;
}

export async function trackUserPageView(router, overrides = {}) {
  if (typeof window === "undefined" || !router?.isReady) return null;

  const payload = buildUserTrackingPayload(router, overrides);
  return postUserTracking(payload);
}

export async function trackNotificationClick(item) {
  if (typeof window === "undefined" || !item) return null;

  const payload = buildNotificationClickTrackingPayload(item);
  return postUserTracking(payload);
}
